import {Injector, NgModule} from '@angular/core';
import {HttpClientModule} from '@angular/common/http';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatButtonModule} from '@angular/material/button';
import {MatTooltipModule} from '@angular/material/tooltip';
import {AddressMapComponent} from './address-map.component';
import {CustomElementService} from '../../../../formbird-sc-shared/src/lib/services/custom-element.service';
import {GeoAutoCompleteModule} from '../../../../formbird-mapping/src/lib/geo-auto-complete/geo-auto-complete.module';
import {SanitizingModule} from '../../../../formbird-mapping/src/lib/sanitizing/sanitizing.module';
import { default as pjson } from '../../../../../package.json';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatTooltipModule,
    // LabelModule,
    HttpClientModule,
    GeoAutoCompleteModule,
    SanitizingModule
  ],
  exports: [
    AddressMapComponent
  ],
  declarations: [
    AddressMapComponent
  ],
  providers: []
})

export class AddressMapModule {
  constructor(private injector: Injector, private customElementService: CustomElementService) {
    customElementService.convertToCustomElement(AddressMapComponent, 'sc-address-map', this.injector, pjson.version);
  }
}
